import React from 'react';

export interface Props {
    logo?: { src: string; altText: string; homePath?: string };
}

const Logo = ({ logo }: Props): JSX.Element => {
    return (
        <a className="header__logo" href={logo?.homePath ?? '/'}>
            <picture>
                <img src={logo?.src} alt={logo?.altText} />
            </picture>
        </a>
    );
};

export default Logo;
